import { render } from "./BattleValue.vue?vue&type=template&id=016555fe&scoped=true"
import script from "./BattleValue.vue?vue&type=script&lang=ts"
export * from "./BattleValue.vue?vue&type=script&lang=ts"

import "./BattleValue.vue?vue&type=style&index=0&id=016555fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-016555fe"

export default script